import {remote} from '../constants/environment';
import {IResponse} from '../interfaces/services/response.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postRegisterDevice = async (
  email: string,
  tokenDevice: string,
  deviceOS: string,
  tokenSession: string,
): Promise<IResponse> => {
  const remoteURI = remote.getRegisterDeviceUri();
  return (await remoteCall(
    async () => {
      const body = {
        payload: {
          email,
          tokenDevice,
          device: deviceOS,
        },
      };

      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': tokenSession,
        },
        body: JSON.stringify(body),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const json: IResponse = await response.json();

        const {success} = json;
        if (success) {
          return {
            success,
            payload: {},
          };
        }
      }
    },
    remoteURI,
  )) as IResponse;
};
